// Dependencies
import React, { FunctionComponent, ReactNode, useState, useEffect } from "react";

// Styles
import { Container } from "./styles";

// Components
import { WebpInput } from "components/WebpInput";

type WebpSearchInputProps = {
    id?: string;
    searchInputValue?: string;
    hasBorder?: boolean;
    searchInputComposition?: ReactNode;
    onWebpDropdownSearchChanged?: (ev: any) => void;
};

export const WebpSearchInput: FunctionComponent<WebpSearchInputProps> = ({
    id,
    onWebpDropdownSearchChanged,
    searchInputComposition,
    hasBorder = true
}) => {
    const [searchInputValue, setSearchInputValue] = useState<string>();

    const handleSearchChange = (e: any) => {
        e.preventDefault();

        setSearchInputValue(e.target.value);

        const detail = {
            id,
            value: e.target.value
        };

        window.document.dispatchEvent(
            new CustomEvent("webpDropdownSearchChanged", {
                detail
            })
        );

        if (!!onWebpDropdownSearchChanged) {
            onWebpDropdownSearchChanged({
                detail
            });
        }
    };

    useEffect(() => {
        window.addEventListener("clearDropdownFilterSearchBox", () => {
            setSearchInputValue("");
        });
    }, []);

    return (
        <Container className="webp-search-input">
            <WebpInput
                placeholder="Buscar"
                value={searchInputValue}
                className="search-input"
                hasBorder={!!hasBorder}
                onWebpInputChange={(e) => handleSearchChange(e)}
            />

            {searchInputComposition}
        </Container>
    );
};
